module.exports = __webpack_public_path__ + "static/media/eris model Ω.972ccfe8.png";